import React from 'react';
import Itinerary from '../../components/Itinerary';

const ItinerarySection = ({
  itineraries,
  selectedItinerary,
  handleCreateNewItinerary,
  handleRenameItinerary,
  handleDeleteItinerary,
  setSelectedItinerary,
  isSectionOpen,
  setIsSectionOpen,
  handleUpdatePrivacy,
  isCreatingItinerary,
  isRenamingItinerary,
  isDeletingItinerary,
  isUpdatingPrivacy,
  toggleMap,
  isSmallScreen,
  showMap,
  readOnly
}) => (
  <section className="section itinerary-section">
    <Itinerary
      onCreateNew={handleCreateNewItinerary}
      onRenameItinerary={handleRenameItinerary}
      onDeleteItinerary={handleDeleteItinerary}
      itineraries={itineraries}
      selectedItinerary={selectedItinerary}
      setSelectedItinerary={setSelectedItinerary}
      isSectionOpen={isSectionOpen.itinerary}
      onUpdatePrivacy={handleUpdatePrivacy}
      isCreatingItinerary={isCreatingItinerary}
      isRenamingItinerary={isRenamingItinerary}
      isDeletingItinerary={isDeletingItinerary}
      isUpdatingPrivacy={isUpdatingPrivacy}
      toggleMap={toggleMap}
      isSmallScreen={isSmallScreen}
      showMap={showMap}
      readOnly={readOnly}
    />
  </section>
);

export default ItinerarySection;
